import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ParametrosRoutesModule } from "./parametro.routing";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {BaseModule} from "../base-module/base.module";
import {provideNgxMask} from "ngx-mask";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { ListaParametroComponent } from "./lista-parametro/lista-parametro.component";
import { ParametroService } from "./services/parametro.service";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTabsModule } from "@angular/material/tabs";
import { MatRadioModule } from "@angular/material/radio";
import { MatMenuModule } from "@angular/material/menu";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatChipsModule } from "@angular/material/chips";
import { MatGridListModule } from "@angular/material/grid-list";


@NgModule({    
    imports: [
        CommonModule,
        ParametrosRoutesModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatTabsModule,
        MatRadioModule, 
        MatMenuModule, 
        MatChipsModule, 
        MatExpansionModule,
        MatFormFieldModule, 
        MatRippleModule, 
        MatSortModule, 
        MatTableModule,
        MatSlideToggleModule,
        FormsModule, 
        ReactiveFormsModule,
        FlexLayoutModule,
        BaseModule,
        CurrencyMaskModule
    ],
    // entryComponents:[], 
    declarations: [
        ListaParametroComponent
    ],
    providers: [
        ParametroService,
        provideNgxMask()
    ],
})

export class ParametrosModule { }
